import Router from 'next/router';
import EmailPasswordReact from 'supertokens-auth-react/recipe/emailpassword';
import PasswordlessReact from 'supertokens-auth-react/recipe/passwordless';
import SessionReact from 'supertokens-auth-react/recipe/session';
import { appInfo } from './appInfo';
import { sanitizeRedirectPath } from '../src/utils/safeRedirect';

const COOKIE_DOMAIN = process.env.NODE_ENV === 'development' ? 'localhost' : '.app.gmb.io';

export const frontendConfig = () => {
  return {
    appInfo,
    recipeList: [
      EmailPasswordReact.init({
        useShadowDom: false,
      }),
      PasswordlessReact.init({
        contactMethod: 'EMAIL',
        useShadowDom: false,
        getRedirectionURL: (context) => {
          if (context.action === 'SUCCESS') {
            // context.redirectToPath comes from loginAttemptInfo (localStorage).
            // For server-initiated magic links (e.g. embed signup), there's no
            // loginAttemptInfo so it's undefined. Fall back to the URL query param.
            const candidate =
              (context as any).redirectToPath ??
              new URLSearchParams(window.location.search).get('redirectToPath');
            return sanitizeRedirectPath(candidate) ?? '/';
          }
          return undefined;
        },
      }),
      SessionReact.init({
        sessionTokenBackendDomain: COOKIE_DOMAIN,
      }),
    ],
    windowHandler: (oI: any) => {
      return {
        ...oI,
        location: {
          ...oI.location,
          setHref: (href: string) => {
            Router.push(href);
          },
        },
      };
    },
  };
};
